var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"hide-label":_vm.icon,"label":_vm.$t('va.actions.associate'),"icon":"mdi-link-plus","color":_vm.color || 'success',"text":"","type":"submit"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }